
const Certificates = [
    {
        name: "Introduction to front-end development",
        link: "https://www.coursera.org/account/accomplishments/verify/8JLM4HVC8B9Z",
        date: "12 July 2023"
    },
    {
        name: "Technical Support Fundamentals",
        link: "https://www.coursera.org/account/accomplishments/verify/Z9JBFYN3QZGW",
        date: "18 July 2023"
    },
    {
        name: "Programming with Javascript",
        link: "https://www.coursera.org/account/accomplishments/verify/QPRP88C38TJK",
        date: "29 July 2023"
    },
    {
        name: "Version Control",
        link: "https://www.coursera.org/account/accomplishments/verify/GWX4RTQ5U6NB",
        date: "9 August 2023"
    },
    {
        name: "The bits and bytes of computer network",
        link: "https://www.coursera.org/account/accomplishments/verify/36ULEV2LM3NK",
        date: "10 August 2023"
    },
    {
        name: "HTML and CSS in depth",
        link: "https://www.coursera.org/account/accomplishments/verify/BBWD5SEFJLBC",
        date: "2 September 2023"
    },
    {
        name: "Operating systems",
        link: "https://www.coursera.org/account/accomplishments/verify/LVBLGH4HGTYN",
        date: "14 September 2023"
    },
    {
        name: "Foundations of UX design",
        link: "https://www.coursera.org/account/accomplishments/verify/G4BNLQ6H8TWL",
        date: "30 September 2023"
    },
    {
        name: "React Basics",
        link: "https://www.coursera.org/account/accomplishments/verify/EBH4YXK983AA",
        date: "11 October 2023",
    },
    {
        name: "Systems administration and I.T infrastructure",
        link: "https://www.coursera.org/account/accomplishments/verify/GSA3GK95HQUV",
        date: "9 December 2023"
    },
    {
        name: "UX design process",
        link: "https://www.coursera.org/account/accomplishments/verify/GNT2YXXLLSP5",
        date: "15 December 2023"
    },
    {
        name: "Google Digital Marketing & E-commerce",
        link: "https://www.coursera.org/account/accomplishments/specialization/certificate/HD9CJ8Q48H6N",
        date: "28 December 2023"
    },
    {
        name: "Wireframes and Low-fidelity protoypes",
        link: "https://www.coursera.org/account/accomplishments/verify/2PHGTR8DM6VR",
        date: "3 January 2024"
    },
    {
        name: "Advanced React",
        link: "https://www.coursera.org/account/accomplishments/verify/RCDJ8KTAXSTU",
        date: "5 January 2024"
    },
    {
        name: "Principles of UI/UX Design",
        link: "https://www.coursera.org/account/accomplishments/verify/N5LEUPXB8DLU",
        date: "7 January 2024"
    },

];

export default Certificates;